import { TooltipPanel } from './TooltipContent';
import { TooltipRoot } from './TooltipRoot';
import { TooltipTrigger } from './TooltipTrigger';

export const Tooltip = Object.freeze({
  Root: TooltipRoot,
  Content: TooltipPanel,
  Trigger: TooltipTrigger,
});
